const claimsCheckingMixin = {

    props: ['info'],

    mounted() {

        //console.info('claimsCheckingMixin -> mounted -> this.info:', this.info);

    }
};

export default claimsCheckingMixin;


// WEBPACK FOOTER //
// ./Content/src/helpers/claims-checking-mixin.js